<div class="header">
  <div class="header-bar">
  <div class="header-left">
    <button mat-icon-button class="menu-toggle" (click)="toggleSidebar()" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>
    <img [src]="currentTheme === 'light' ? 'assets/images/logo_ngx_light.png' : 'assets/images/logo_ngx.png'" alt="NGX" class="app-brand-logo" />
    <!-- §4: breadcrumb above the page H1, stacked in the header band left column.
         Title/crumbs come from app-breadcrumb (route-derived), not hard-coded here. -->
    <div class="header-heading">
      <app-breadcrumb #breadcrumb></app-breadcrumb>
      <h1 class="header-page-title">{{ breadcrumb.pageTitle }}</h1>
    </div>
  </div>

  <div class="header-right">
    <!-- §4: global search pill (visual only — no search logic wired here) -->
    <div class="header-search">
      <mat-icon class="header-search-icon">search</mat-icon>
      <input
        type="text"
        class="header-search-input"
        [placeholder]="'header.search_placeholder' | translate"
        aria-label="Buscar"
        readonly
      />
      <span class="header-search-kbd">⌘K</span>
    </div>

    <!-- Hide/show values toggle -->
    <button
      mat-icon-button
      class="visibility-btn"
      [class.active]="visibilityService.isHidden"
      (click)="visibilityService.toggle()"
      [matTooltip]="visibilityService.isHidden ? 'Mostrar valores' : 'Ocultar valores'"
    >
      <mat-icon>{{ visibilityService.isHidden ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>

    <!-- Language selector -->
    <button
      mat-icon-button
      class="lang-btn"
      [matMenuTriggerFor]="langMenu"
      matTooltip="{{ 'common_ext.language' | translate }}"
    >
      <span class="lang-badge">{{ currentLang === 'pt-br' ? 'PT' : 'EN' }}</span>
    </button>
    <mat-menu #langMenu="matMenu">
      <button mat-menu-item (click)="switchLanguage('pt-br')" [class.active-lang]="currentLang === 'pt-br'">
        <span>{{ 'common_ext.pt_br' | translate }}</span>
      </button>
      <button mat-menu-item (click)="switchLanguage('en')" [class.active-lang]="currentLang === 'en'">
        <span>{{ 'common_ext.en' | translate }}</span>
      </button>
    </mat-menu>

    <!-- Theme toggle -->
    <button mat-icon-button (click)="toggleTheme()" [matTooltip]="currentTheme === 'dark' ? ('header.theme_light' | translate) : ('header.theme_dark' | translate)">
      <mat-icon>{{ currentTheme === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>

    <!-- Notifications placeholder -->
    <button mat-icon-button class="notifications-btn" matTooltip="{{ 'header.notifications' | translate }}">
      <mat-icon>notifications_none</mat-icon>
      <!-- Visual/placeholder badge: static count — no real notification counter wired yet. -->
      <span class="notifications-badge" aria-hidden="true">3</span>
    </button>

    <!-- User menu -->
    <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-button">
      <div class="user-avatar">
        {{ currentUser?.nome?.charAt(0)?.toUpperCase() }}
      </div>
    </button>
    <mat-menu #userMenu="matMenu">
      <div class="user-info" mat-menu-item disabled>
        <strong>{{ currentUser?.nome }}</strong>
        <small>{{ currentUser?.email }}</small>
      </div>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="toggleTheme()">
        <mat-icon>{{ currentTheme === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
        <span>{{ currentTheme === 'dark' ? ('header.theme_light' | translate) : ('header.theme_dark' | translate) }}</span>
      </button>
      <button mat-menu-item [matMenuTriggerFor]="langMenu">
        <mat-icon>language</mat-icon>
        <span>{{ currentLang === 'pt-br' ? 'Português (BR)' : 'English' }}</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item routerLink="/settings">
        <mat-icon>settings</mat-icon>
        <span>{{ 'sidebar.settings' | translate }}</span>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'auth.logout' | translate }}</span>
      </button>
    </mat-menu>
  </div>
  </div>
</div>
